import { Alert } from "@sirdab/ui";

import { useOnline } from "../hooks/useOnline";
import { useMessages } from "../i18n";

/**
 * Sticky, above everything, whenever the browser reports no connection. A shopper on
 * patchy mobile data who taps Submit into the void will message the merchant instead —
 * telling them the connection dropped is cheaper than a support ticket.
 *
 * `inset-x-0` rather than left/right, so it is direction-agnostic by construction.
 */
export function OfflineBanner(): React.JSX.Element | null {
  const online = useOnline();
  const { t } = useMessages();
  if (online) return null;
  return (
    <div className="z-sticky sticky inset-x-0 top-0 p-2">
      <Alert variant="warning" aria-live="polite" className="text-center">
        {t("ui.offline")}
      </Alert>
    </div>
  );
}
